import { BuilderElementType } from '@website-builder/model/domain/builder-element-type.enum';
import { BaseMultipleWidget } from '@website-builder/widgets/base/base-multiple-widget';
import { SlideshowButtonStyle } from '@website-builder/widgets/slidershow/model/slideshow-button-style';
import { SlideshowTitleStyle } from '@website-builder/widgets/slidershow/model/slideshow-title-style';
import { SlideshowSubtitleStyle } from '@website-builder/widgets/slidershow/model/slideshow-subtitle-style';
import { SlideshowOverlay } from '@website-builder/widgets/slidershow/model/slideshow-verlay';
import { SlideshowContentStyle } from '@website-builder/widgets/slidershow/model/slideshow-content-style';
import { SlideshowSlideNav } from '@website-builder/widgets/slidershow/model/slideshow-slide-nav';
import { SlideshowNavigation } from '@website-builder/widgets/slidershow/model/slideshow-navigation';
import { SlideshowConfig } from '@website-builder/widgets/slidershow/model/slideshow-config';
import { SlideshowStyle } from '@website-builder/widgets/slidershow/model/slideshow-style';
import { SlideshowElement } from '@website-builder/widgets/slidershow/slideshow-element';
import { BaseWidgetNormalizer } from '@website-builder/widgets/normalizer/base-widget-normalizer';

export class SlideshowWidget extends BaseMultipleWidget<SlideshowElement, SlideshowStyle> {
  readonly type = BuilderElementType.Slideshow;
  name: string;
  style = new SlideshowStyle();
  config = new SlideshowConfig();
  navigation = new SlideshowNavigation();
  slideNav = new SlideshowSlideNav();
  overlay = new SlideshowOverlay();
  titleStyle = new SlideshowTitleStyle();
  subtitleStyle = new SlideshowSubtitleStyle();
  contentStyle = new SlideshowContentStyle();
  buttonStyle = new SlideshowButtonStyle();

  height: number;
  minHeight = 600;

  elements = [
    new SlideshowElement('assets/images/builder/placeholders/cityview.png'),
    new SlideshowElement('assets/images/builder/placeholders/cityscape.png'),
    new SlideshowElement('assets/images/builder/placeholders/mountain.png'),
  ];

  static normalizeInPlace(widget: SlideshowWidget): SlideshowWidget {
    const pureWidget = new SlideshowWidget();

    BaseWidgetNormalizer.normalizeInPlace(widget, pureWidget);

    widget.name = widget.name ?? pureWidget.name;
    widget.height = widget.height ?? pureWidget.height;
    widget.minHeight = widget.minHeight ?? pureWidget.minHeight;
    widget.elements = (widget.elements ?? pureWidget.elements).map(element => SlideshowElement.normalizeInPlace(element));

    widget.style = SlideshowStyle.normalize(widget.style);
    widget.config = SlideshowConfig.normalize(widget.config);
    widget.navigation = SlideshowNavigation.normalize(widget.navigation);
    widget.slideNav = SlideshowSlideNav.normalize(widget.slideNav);
    widget.overlay = SlideshowOverlay.normalize(widget.overlay);
    widget.titleStyle = SlideshowTitleStyle.normalize(widget.titleStyle);
    widget.subtitleStyle = SlideshowSubtitleStyle.normalize(widget.subtitleStyle);
    widget.contentStyle = SlideshowContentStyle.normalize(widget.contentStyle);
    widget.buttonStyle = SlideshowButtonStyle.normalize(widget.buttonStyle);

    return widget;
  }
}
